export default [  
  {
    path: '/stakeholders',
    name: 'stakeholders',
    component: () => import('@/views/modules/stakeholders/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Stakeholders List',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Stakeholders' }
      ]
    },
    children:[
      {
        path: '/stakeholders/create',
        name: 'stakeholders-create',
        component: () => import('@/views/modules/stakeholders/create'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Stakeholder Create',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Stakeholders', link: '/stakeholders' },
            { text: 'Create' }
          ]
        }
      },
      {
        path: '/stakeholders/:id/edit',
        props: true,
        name: 'stakeholders-edit',
        component: () => import('@/views/modules/stakeholders/edit'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Stakeholders Edit',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Stakeholder',  to: { name: "stakeholders-show" }, param: 'id' },
            { text: 'Edit' }
          ]
        }
      },
      {
        path: '/stakeholders/:id/show',
        props: true,
        name: 'stakeholders-show',
        component: () => import('@/views/modules/stakeholders/show'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Stakeholders Details',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Stakeholders',  to: { name: "stakeholders" } },
            { text: 'Details' }
          ]
        }
      },
    
    ]
  },

 
]